module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_M2-830e86a028aca0b56ff916664546ab7d.png";